import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex flex-row py-1"
};
const _hoisted_2 = {
  class: "flex grow basis-1 text-right items-center justify-end text-sm"
};
const _hoisted_3 = {
  class: "flex flex-col items-center justify-center w-12"
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode("--");
const _hoisted_5 = {
  key: 2,
  class: "text-xs text-slate-700"
};
const _hoisted_6 = {
  key: 3,
  class: "text-xs text-slate-700"
};
const _hoisted_7 = {
  class: "flex grow basis-1 items-center text-sm"
};
import EntityLink from "@/modules/vue/components/EntityLink.vue";
import MatchModal from "@/modules/match/components/MatchModal.vue";
import Marker from "@/modules/competitions/components/divisions/Table/Marker.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Match',
  props: {
    match: null,
    markerWinner: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NTag = _resolveComponent("NTag");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.markerWinner && __props.match.homeTeam.id === __props.markerWinner.id ? (_openBlock(), _createBlock(Marker, {
        key: 0,
        class: "mr-1",
        color: _ctx.ColorEnum.Gold
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.Crown,
          size: "1rem"
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["color"])) : _createCommentVNode("", true), _createVNode(EntityLink, {
        entity: __props.match.homeTeam,
        class: _normalizeClass(__props.match.homeTeam.id === __props.match.advancedTeamId ? 'font-semibold' : null),
        orientation: "right"
      }, null, 8, ["entity", "class"]), __props.match.homeEffectiveSkill ? (_openBlock(), _createBlock(_component_NTag, {
        key: 1,
        type: "info",
        size: "small",
        class: "ml-1"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.match.homeEffectiveSkill), 1)]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [__props.match.result ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", {
        class: "font-bold cursor-pointer",
        onClick: _cache[0] || (_cache[0] = () => _ctx.$refs.matchModal.show())
      }, _toDisplayString(__props.match.homeGoals) + " : " + _toDisplayString(__props.match.awayGoals), 1), _createVNode(MatchModal, {
        ref: "matchModal",
        match: __props.match
      }, null, 8, ["match"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_4], 64)), __props.match.penalty ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('penalty_time_short')), 1)) : __props.match.extraTime ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('extra_time_short')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [__props.match.awayEffectiveSkill ? (_openBlock(), _createBlock(_component_NTag, {
        key: 0,
        type: "info",
        size: "small",
        class: "mr-1"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.match.awayEffectiveSkill), 1)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(EntityLink, {
        entity: __props.match.awayTeam,
        class: _normalizeClass(__props.match.awayTeam.id === __props.match.advancedTeamId ? 'font-semibold' : '')
      }, null, 8, ["entity", "class"]), __props.markerWinner && __props.match.awayTeam.id === __props.markerWinner.id ? (_openBlock(), _createBlock(Marker, {
        key: 1,
        class: "ml-1",
        color: _ctx.ColorEnum.Gold
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.Crown,
          size: "1rem"
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["color"])) : _createCommentVNode("", true)])]);
    };
  }
});